/**
 * App mode: seeker (Get Work Done) | provider (Work & Earn)
 */
export const MODES = {
  SEEKER: 'seeker',
  PROVIDER: 'provider',
};

export const MODE_LABELS = {
  seeker: 'Get Work Done',
  provider: 'Work & Earn',
};

const STORAGE_KEY = 'zoopup_mode';
const DEFAULT_MODE = MODES.SEEKER;

function readStoredMode() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === MODES.SEEKER || stored === MODES.PROVIDER) {
    return stored;
  }
  return DEFAULT_MODE;
}

export default {
  namespaced: true,
  state: {
    mode: readStoredMode(),
  },
  getters: {
    mode: state => state.mode,
    isSeeker: state => state.mode === MODES.SEEKER,
    isProvider: state => state.mode === MODES.PROVIDER,
    modeLabel: state => MODE_LABELS[state.mode] || MODE_LABELS[DEFAULT_MODE],
    oppositeMode: state => (state.mode === MODES.SEEKER ? MODES.PROVIDER : MODES.SEEKER),
    oppositeModeLabel: state =>
      MODE_LABELS[state.mode === MODES.SEEKER ? MODES.PROVIDER : MODES.SEEKER],
  },
  mutations: {
    SET_MODE(state, mode) {
      if (mode !== MODES.SEEKER && mode !== MODES.PROVIDER) return;
      state.mode = mode;
      localStorage.setItem(STORAGE_KEY, mode);
    },
  },
  actions: {
    setMode({ commit, rootState }, mode) {
      commit('SET_MODE', mode);
      // Persist to server when authenticated (best-effort)
      if (rootState.user && rootState.user.user_id) {
        import('../../dataservice').then(({ default: DataService }) => {
          DataService.saveUserMode?.({ mode }).catch(() => {});
        });
      }
    },
    toggleMode({ state, dispatch }) {
      const next = state.mode === MODES.SEEKER ? MODES.PROVIDER : MODES.SEEKER;
      dispatch('setMode', next);
    },
    initFromUser({ commit }, user) {
      if (user?.preferred_mode === MODES.SEEKER || user?.preferred_mode === MODES.PROVIDER) {
        commit('SET_MODE', user.preferred_mode);
      }
    },
  },
};
